<template>
  <div class="video-preview-back">
    <div class="left">
      <video-preview
        ref="videoPreview"
        :mode="mode"
        :src="videoSrc"
        :code="previewCode"
        :hkCode="hkVideoCode"
        :hkConfig="hkConfig"
        :videojsOption="videojsOption"
        :univiewCode="ysCode"
        :configUrl="configUrl"
        :dhIccOptions="dhIccOptions"
        DHvideoType='video2'
      ></video-preview>
    </div>
    <div class="right">
      <el-date-picker
        size="small"
        popper-class="vp-date-popper"
        class="mb10 vp-block"
        v-model="videoBackForm.date"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
      >
      </el-date-picker>
      <!-- myeyes不显示 -->
      <el-time-picker
        v-if="iotVideoObj && ['dahuaicc','dahua8900', 'myeyes', 'icvs', 'zlk', 'minking'].indexOf(iotVideoObj.source) == -1"
        popper-class="vp-date-popper"
        size="small"
        class="mb10 vp-block"
        is-range
        value-format="HH:mm:ss"
        v-model="videoBackForm.videoTime"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        placeholder="选择时间范围"
      >
      </el-time-picker>
      <el-radio-group
        class="mb10 vp-block"
        v-model="videoBackForm.recordLocation"
      >
        <el-radio :label="0">服务器存储</el-radio>
        <el-radio :label="1">设备存储</el-radio>
      </el-radio-group>
      <div>
        <el-button size="mini" class="vp-button" @click="queryVideoRecord"
          >查询/播放录像</el-button
        >
      </div>
      <el-table
        v-if="recordList.length > 0"
        size="mini"
        class="vp-table"
        header-row-class-name="vp-table-header"
        height="calc(100% - 160px)"
        style="width: 100%"
        :data="recordList"
      >
        <el-table-column
          label="时间"
        >
          <template slot-scope="scope">
            <span style="color: #606266;">{{ splitDay(scope.row.recordTimeStart) }}-{{ splitDay(scope.row.recordTimeEnd) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预览" width="60">
          <template slot-scope="scope">
            <img
              width="16px"
              :src="videoback"
              @click="handleSelectionChange(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import axios from './axios'
import videoPreview from "./videoPreview.vue";
import pick from "lodash/pick";
import merge from "lodash/merge";
import { SOURCE_ENUM, URLS, VIDEO_MODE_ENUM } from "../config";
import videoback from "./../assets/videoback.png";
import { splitDay } from '../utils';
import { VDate } from "./../utils/date";

export default {
  name: "video-back",
  components: { videoPreview },
  props: {
    // 播放来源
    code: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      default: "",
    },
    mode0: {
      type: String,
      default: "0",
    },
    configUrl: {
      type: Object,
      default: () => {
        return null;
      },
    },
    proxyHost: { type: String, default: "" },
    videojsOption: Object,
    dhIccOptions: {
      type:Object,
      default:()=>{
        return {
          videoId: 'realPlayer',
          division:1 ,
          windowType: '7'
      }
      }
    },
    hkConfig: {
      type: Object,
      default: () => {
        return {
          playMode: 1,
        }
      }
    }, 
  },
  watch: {
    code: {
      handler(nVal) {
        nVal && this.start()
      },
      deep: true,
      immediate:true,
    },
  },
  data() {
    return {
      splitDay,
      videoback,
      SOURCE_ENUM,
      videoTime: null,
      videoDate: "",
      flag: false,
      tableData: [],
      startTime: "",
      endTime: "  ",
      recordLocation: 1,
      // hkConfig: {
      //   playMode: 1,
      // },
      mode: "",
      source: "",
      ysCode: "",
      recordList: [],
      videoBackForm: {
        date: "",
        videoTime: ["", ""],
        recordLocation: 0,
      },
      hkVideoCode: "",
      videoSrc: "",
      iotVideoObj: null,
      dhVideoCode:'',
      previewCode:'',
    };
  },
  mounted() {
    this.start();
  },
  methods: {
    async start() {
      const { code } = this;
      // 如果当前组件包含code 走公司内部播放流程
      if (code) {
        const url = this.proxyHost + URLS.getVideoUrl
        let params = {
          params: {
            categoryName: "",
            categoryId: "",
            search: "",
            code,
            codeSign: "equal",
            name: "",
            nameSign: "",
            pageSize: 150,
            pageNum: 1,
            time: "",
            timeSign: "",
            starttime: "",
            endtime: "",
          },
        };
        let res = await axios.get(url, params);
        if (res && res.status === 200 && res.data.result.list.length > 0) {
          this.mode = res.data.result.list[0].mode;
          const videoSrc = res.data.result.list[0].stream
          this.source = res.data.result.list[0].source;
          const hkVideoCode = res.data.result.list[0].code;
          this.dhCode = res.data.result.list[0].code;
          const univiewCode = res.data.result.list[0].code;
          this.iotVideoObj = res.data.result.list[0];
          // this.ysCode = res.data.result.list[0].code;
          // this.$nextTick(() => {
          //   console.error('init-----======= code',this.iotVideoObj);
          //   this.$refs.videoPreview.init();
          // });
          this.setVideoVal(videoSrc, this.mode, hkVideoCode, this.dhCode ,univiewCode)
        }
      }else if (this.src) {
          this.setVideoVal(this.src, this.mode0, 0, 0)
          setTimeout(() => {
            console.error('init-----=======',this.src, this.mode,this.videoSrc);
            this.$refs.videoPreview.init()
          }, 1000)
        } else {
         console.error('请传入视频URL使用！|| 请传入物联网视频编码使用！')
        }
    },
    // 除海康需视同code外其余的均为url
    setVideoVal(src, mode, hkCode, dhCode, univiewCode) {
      this.hkVideoCode = '';
      this.videoSrc = '';
      if (typeof mode === 'string') {
        this.mode = Number(mode)
      } else {
        this.mode = mode
      }
      this.$nextTick(() => {
        if (this.mode == 0) {
          this.videoSrc = src
        } else if (this.mode == 1) {
          this.videoSrc = src
        } else if (this.mode == 2) {
          if(src)(this.videoSrc = src);
          else(this.previewCode = hkCode);
        } else if (this.mode == 3) {
          this.hkVideoCode = hkCode
        } else if (this.mode == 8) {
          this.dhVideoCode = dhCode
        } else if (this.mode == 7) {
          this.mjConfigStr = src
        } else if (this.mode == 11) {
          this.videoSrc = src
        } else if (this.mode == 13) {
          this.videoSrc = src
        } else if (this.mode == 14) {
          this.videoSrc = src
        } else if (this.mode == 15) {
          this.ysCode = univiewCode
        } else if (this.mode == 16) {
          this.videoSrc = src
        }
      })
    },
    // 查询录像
    queryVideoRecord() {
      if (!this.iotVideoObj) {
        console.error('IOT视频对象不存在！请检查！');
        return;
      }
      switch (this.iotVideoObj.source) {
        case SOURCE_ENUM.uniview:
        case SOURCE_ENUM.hikvision:
          this.hkVideoRecord();
          break;
        case SOURCE_ENUM.myeyes:
          this.myeyesVideoRecord();
          break;
        case SOURCE_ENUM.icvs:
          this.commonVideoRecord(SOURCE_ENUM.icvs)
          break
        case SOURCE_ENUM.dahuaicc:
          this.commonVideoRecord(SOURCE_ENUM.dahuaicc)
          break
        case SOURCE_ENUM.dahua8900:
          this.commonVideoRecord(SOURCE_ENUM.dahua8900)
          break
        case SOURCE_ENUM.zlk:
          this.commonVideoRecord(SOURCE_ENUM.zlk)
          break
        case SOURCE_ENUM.minking:
          this.commonVideoRecord(SOURCE_ENUM.minking)
          break
        case SOURCE_ENUM.ay:
          this.ayVideoRecord()
          break
        default:
          console.error("当前视频不包含回放功能！请确认视频来源后进行处理！")
          // this.commonVideoRecord();
          break;
      }
    },
    // 安元平台回放
    ayVideoRecord() {
      if (!this.videoBackForm.date || !this.videoBackForm.videoTime[0] || !this.videoBackForm.videoTime[1]) {
        console.error('请选择时间')
        return
      }
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'server' : 'device'
      const url = this.proxyHost + URLS.ayVideoRecordUrl
      const params = {
        loc: recordFrom,
        // id: this.code,
        id:this.iotVideoObj.channelId,
        start: new Date(this.videoBackForm.date + ` ${this.videoBackForm.videoTime[0]}`).getTime(),
        end: new Date(this.videoBackForm.date + ` ${this.videoBackForm.videoTime[1]}`).getTime()
      }

      axios.get(url, { params }).then((res) => {
        if (res && res.status === 200 && res.data.code === 200) {
          this.recordList = res.data.result.map((item) => {
            item.recordTimeStart = item.startTime
            item.recordTimeEnd = item.endTime
            return item
          })
        }
      })
    },
    // icvs回放 后续等接口稳定后做成通用回放
    commonVideoRecord(type) {
      if (!this.videoBackForm.date) {
        console.error('请选择时间')
        return
      }
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'server' : 'device'
      const url = this.proxyHost + URLS.listRecords

      const params = {
        code: this.code,
        recordFrom: recordFrom,
        date: this.videoBackForm.date
      }
      axios.get(url, { params }).then((res) => {
        this.recordList = res.data.result.map((item) => {
          if (type == SOURCE_ENUM.minking) {
            item.recordTimeStart = VDate.formatTimeStamp(item.begin, "YYYY-MM-DD hh:ii:ss", true, false)
            item.recordTimeEnd = VDate.formatTimeStamp(item.end, "YYYY-MM-DD hh:ii:ss", true, false)
            return item;
          }
          if (type == SOURCE_ENUM.dahuaicc) {
            item.recordTimeStart = VDate.formatTimeStamp(item.startTime, "YYYY-MM-DD hh:ii:ss", true, false)
            item.recordTimeEnd = VDate.formatTimeStamp(item.endTime, "YYYY-MM-DD hh:ii:ss", true, false)
            return item;
          }
          if (type == SOURCE_ENUM.dahua8900) {
            item.recordTimeStart = VDate.formatTimeStamp(item.startTime, "YYYY-MM-DD hh:ii:ss", true, false)
            item.recordTimeEnd = VDate.formatTimeStamp(item.endTime, "YYYY-MM-DD hh:ii:ss", true, false)
            return item;
          }
          if (type == SOURCE_ENUM.zlk) {
            const sItem = {}
            let reg = new RegExp(/[0-9]{4}-[0-9]{2}-[0-9]{2}\/[0-9]{2}-[0-9]{2}-[0-9]{2}/gm);
            const result = item.match(reg)[0]
            if (result) {
              let splitTime = result.split('/');
              let hms = splitTime[1].replaceAll('-', ':')
              sItem.recordTimeStart = `${splitTime[0]} ${hms}`
            }
            sItem.url = item
            return sItem;
          }
          item.recordTimeStart = VDate.formatTimeStamp(item.Begin)
          item.recordTimeEnd = VDate.formatTimeStamp(item.End)
          return item
        })
      })
    },
    // 海康回放
    hkVideoRecord() {
      if (
        !this.videoBackForm.date ||
        !this.videoBackForm.videoTime[0] ||
        !this.videoBackForm.videoTime[1]
      ) {
        console.error("请选择时间");
        return;
      }
      // 海康自有播放器 回放
      if (this.mode == VIDEO_MODE_ENUM.hkPlayer) {
        this.startTime = new Date(
          this.videoBackForm.date + ` ${this.videoBackForm.videoTime[0]}`
        ).getTime();
        this.endTime = new Date(
          this.videoBackForm.date + ` ${this.videoBackForm.videoTime[1]}`
        ).getTime();

        this.$refs.videoPreview.previewBack(
          this.startTime,
          this.endTime,
          this.hkVideoCode,
          this.videoBackForm.recordLocation
        );
      } else if(this.mode == VIDEO_MODE_ENUM.uniview) {
        this.startTime = new Date(
          this.videoBackForm.date + ` ${this.videoBackForm.videoTime[0]}`
        );
        this.endTime = new Date(
          this.videoBackForm.date + ` ${this.videoBackForm.videoTime[1]}`
        )
        this.$refs.videoPreview.previewBack(
          this.startTime,
          this.endTime,
          this.code,
          this.videoBackForm.recordLocation
        );
      }
    },
    previewBack(startTime, endTime) {
        setTimeout(()=>this.$refs.videoPreview.previewBack(startTime, endTime, this.hkVideoCode, 0),2000)
    },
    // myeyes回放
    myeyesVideoRecord() {
      if (!this.videoBackForm.date) {
        console.error("请选择时间");
        return;
      }
      const url = this.proxyHost + URLS.myeyesVideoRecordsList
      const recordFrom =
        this.videoBackForm.recordLocation === 0 ? "ss" : "device";
      const params = {
        code: this.code,
        queryDay: this.videoBackForm.date,
        recordFrom,
      };
      axios.get(url, { params }).then((res) => {
        if (res && res.data.status === 200 && res.data.code === 200) {
          this.recordList = res.data.result;
        }
      });
    },
    handleSelectionChange(row) {
      // myeyes record play
      switch (this.iotVideoObj.source) {
        case SOURCE_ENUM.myeyes:
          this.myeyesRecordPlay(row);
          break;
        case SOURCE_ENUM.icvs:
          this.icvsRecordPlay(row);
          break;
        case SOURCE_ENUM.dahuaicc:
          this.icvsRecordPlay(row,SOURCE_ENUM.dahuaicc);
          break;
        case SOURCE_ENUM.dahua8900:
          this.icvsRecordPlay(row,SOURCE_ENUM.dahua8900);
          break;
        case SOURCE_ENUM.zlk:
          this.icvsRecordPlay(row, SOURCE_ENUM.zlk);
          break;
        case SOURCE_ENUM.minking:
          this.mjRecordPlay(row);
          break;
        case SOURCE_ENUM.ay:
          this.ayRecordPlay(row)
          break
        case SOURCE_ENUM.ay:
          this.ayRecordPlay(row)
          break
        default:
          break;
      }
    },
    ayRecordPlay(row) {
      const url = this.proxyHost + URLS.ayVideoRecordPlayUrl
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'server' : 'device'
      const params = {
        id: this.code,
        start: row.recordTimeStart,
        end: row.recordTimeEnd,
        loc: recordFrom
      }
      axios.get(url, { params }).then((res) => {
        if (res && res.data.status === 200) {
          this.isPlaybackFlag = true
          this.videoSrc = res.data.result
        }
      })
    },
    myeyesRecordPlay(row) {
      const url = this.proxyHost + URLS.myeyesVideoCallbackUrl
      const dataSource = pick(this.iotVideoObj, [
        "code",
        "streamType",
        "mediaType",
      ]);
      const record = pick(row, [
        "recordTimeStart",
        "recordTimeEnd",
        "recordName",
      ]);
      const params = merge(dataSource, record);
      params.recordFrom =
        this.videoBackForm.recordLocation === 0 ? "ss" : "device";
      axios.post(url, params).then((res) => {
        if (res && res.data.status === 200) {
          this.videoSrc = res.data.result;
        }
      });
    },
    // # https://icvs.icarebb.com/apidoc/#api-sg-VODFile.flv
    icvsRecordPlay(row, source) {
      if (source === SOURCE_ENUM.zlk) {
        this.videoSrc = row.url;
        return
      }
      const url = this.proxyHost + URLS.getRecordUri
      const recordFrom =
        this.videoBackForm.recordLocation === 0 ? "server" : "device";
      const params = {
        ...row,
        recordFrom,
        code: this.iotVideoObj.code
      }
      axios.post(url, params).then((res) => {
        if (res && res.data.status === 200) {
          this.videoSrc = res.data.result;
          if (source === SOURCE_ENUM.dahuaicc) {
            this.mode = '16';
          }
          if (source === SOURCE_ENUM.dahua8900) {
            this.mode = '16';
          }
        }
      });
    },
    //
    mjRecordPlay(row) {
      const url = this.proxyHost + URLS.mjGetUri
      const recordFrom = this.videoBackForm.recordLocation === 0 ? 'server' : 'device'
      const params = {
        rName: row.name,
        recordFrom,
        code: this.iotVideoObj.code
      }
      axios.post(url, params).then((res) => {
        if (res && res.data.status === 200) {
          const configObj = JSON.parse(res.data.result)
          const data = JSON.stringify({
            ...configObj,
            req: newGUID(),
            name: 'playback',
            cmd: 'create',
            image: 3 // 0-RGB 1-YUV 2-bmp 3-JPEG
          })
          this.$refs.videoPreview.restartWebSocket('ws://127.0.0.1:23350', data)
        }
      })
    },
     // dispose卸载
    dispose() {
      this.$refs.videoPreview.dispose()
    },
    init() {
      this.$refs.videoPreview.init()
    },
  },
};
</script>
<style lang="scss">
// over element
.video-preview-back {
  .el-input__inner {
    border-radius: 0px;
    border: 1px solid #dbdbdb;
  }
  .vp-table {
    .vp-table-header {
      font-size: 12px;
    }
  }
  .el-radio+.el-radio {
    margin-left: 0px;
  }
}
</style>
<style lang="scss" scoped>
#playWnd {
  width: 100%;
  height: 420px;
}

.playWnd {
  text-align: center;
  background: #3d3d3d;
}
.playWnd .tip {
  padding-top: 20%;
  color: #fff;
  display: block;
  font-size: 18px;
  line-height: 158%;
}
.playWnd .tip a {
  padding-top: 10%;
  color: #f60;
}

.video-preview-back {
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  max-height: 450px;
  .left {
    display: flex;
    flex: 1 1 auto;
    height: 450px;
    max-height: 450px;
    flex-direction: row;
  }
  .right {
    display: flex;
    flex: 0 0 220px;
    width: 220px;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin-left: 10px;
    .vp-block {
      width: 100%;
    }
  }
}
</style>
